import { CivilMattersNewMexico } from './CivilMattersNewMexico';

export default CivilMattersNewMexico;
